import React, { useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import { useBrand } from "../../context/BrandContext";
import { resolveClubImageUrl } from "../../utils/resolveClubImageUrl";
import defaultAppLogo from "../../assets/smarttt-default-logo.png";

/**
 * Club branding mark for live training — brand API logo with user club fallbacks.
 */
export function LiveTrainingClubLogo({
  user = null,
  size = "md",
  className = "",
  showName = false,
}) {
  const { t } = useTranslation();
  const { brand } = useBrand();
  const [failed, setFailed] = useState(false);

  const logoSrc = useMemo(() => {
    if (failed) return defaultAppLogo;
    return (
      resolveClubImageUrl(brand?.logo_url) ||
      resolveClubImageUrl(user?.club_details?.club_image) ||
      resolveClubImageUrl(user?.club?.club_image) ||
      defaultAppLogo
    );
  }, [brand?.logo_url, user, failed]);

  const clubName =
    brand?.brand_name ||
    brand?.brand_short_name ||
    user?.club?.club_name ||
    user?.club_details?.club_name ||
    null;

  return (
    <div
      className={`lt-club-logo-wrap lt-club-logo-wrap--${size}${className ? ` ${className}` : ""}`}
    >
      <img
        src={logoSrc}
        alt={clubName || t("clubLogo") || "Club logo"}
        className={`lt-club-logo lt-club-logo--${size}`}
        onError={() => setFailed(true)}
      />
      {showName && clubName ? (
        <span className="lt-club-logo-wrap__name">{clubName}</span>
      ) : null}
    </div>
  );
}

export default LiveTrainingClubLogo;
